export default function(ids) {
  return ids.reduce(
    (result, id, index) => (index < 17 ? `${result}${id[0]}` : result),
    ""
  );
}
